const IGNORE_ERRORS = [
  'ResizeObserver',
  'ChunkLoadError',
];

export default {
  enabled: process.env.VUE_APP_ROLLBAR_ENABLED === 'true',
  accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
  itemsPerMinute: 10,
  maxItems: 100,
  captureUncaught: true,
  captureUnhandledRejections: true,
  checkIgnore: (isUncaught, args) => {
    const err = args[0];
    const message = err?.message || err || '';
    const name = err?.name || '';
    return IGNORE_ERRORS.some((error) => message.includes(error) || name.includes(error));
  },
  payload: {
    environment: process.env.VUE_APP_ENV || 'development',
    client: {
      javascript: {
        source_map_enabled: true,
      },
    },
  },
};
